import { advanceTask } from './advanceTask'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, registerJob } from './jobs'
import { createTask_placeInEmptySpace } from './taskPlaceInEmptySpace'
import { createTask_putAway } from './taskPutAway'

export const register = () => registerJob('put-away-carried-cargo', advanceJob)

function advanceJob(job: IJob) {
  jobLogger.assertJobType(job, 'put-away-carried-cargo')
  let m = jobLogger.assertReserved(job)

  // Seed job tasks
  if (job.tasks.length === 0) {
    // TODO: try to stack?

    // Put down in open spot
    let task = createTask_putAway(m.i, m.j)
    job.tasks.push(task)

    return
  }

  if (job.tasks.length > 0) {
    advanceTask(job)
  }
}
